(ns portal.agency-selection-page.view
  (:require ["@mui/material/Button$default" :as Button]
            [common.queries :refer [use-query]]
            [common.resource.query.advertiser :refer [advertisers-query]]
            [common.widgets.auth-card :refer [auth-card]]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.page :as page]
            [portal.agency-selection-page.db :as form]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [defui $]]
            [uix.re-frame :refer [use-subscribe]]))

(defui agency-selection-page []
  (let [form-selection-agencies (use-subscribe [:form.agency-selection/agencies])
        form-values (use-subscribe [:form.agency-selection/value []])
        {on-change-agency :on-change :as agency-control} (form/use-bind-control [:agency])

        {:keys [isFetching] advertisers :data} (use-query (advertisers-query))
        advertiser-options (->> advertisers
                                (map #(hash-map :label (:name %) :value (:id %)))
                                (sort-by :label)
                                vec)

        advertiser-input-value (uix/use-ref "")
        is-advertiser-create-allowed (use-subscribe [:resource.user/allowed? "advertisers.create"])
        on-create-advertiser (uix/use-callback
                              (fn [advertiser]
                                (rf/dispatch [:form.agency-selection/submit-form
                                              (assoc form-values :advertiser (:id advertiser))]))
                              [form-values])]
    (uix/use-effect (fn []
                      (rf/dispatch [:form.agency-selection/init-form]))
                    [])
    ($ page/page {:sidebar false
                  :appbar false}
       ($ page/content-padding
          ($ auth-card {:on-submit #(rf/dispatch [:form.agency-selection/submit])}
             ($ form-field
                {:label "Agency"
                 :err-msg (form/use-error-message [:agency])}
                (r/as-element
                 [dropdown
                  (merge agency-control
                         {:on-change (fn [value]
                                       (on-change-agency value)
                                       (rf/dispatch [:resource.auth/switch-agency value]))
                          :options form-selection-agencies
                          :data-testid "list-agencies"})]))
             ($ form-field
                {:label "Advertiser"
                 :err-msg (form/use-error-message [:advertiser])}
                (r/as-element
                 [dropdown
                  (merge (form/use-bind-control [:advertiser])
                         {:clearable? true
                          :onInputChange (fn [^js _event ^js new-input-value]
                                           (reset! advertiser-input-value new-input-value))
                          :options (cond-> advertiser-options
                                     is-advertiser-create-allowed
                                     (conj {:icon "add"
                                            :label "Create new advertiser"
                                            :value :nothing
                                            :on-click #(rf/dispatch [:modal/open {:id :advertiser/create
                                                                                  :props {:on-success on-create-advertiser
                                                                                          :name @advertiser-input-value}}])}))
                          :no-options-text "No advertisers - please contact support to create a new advertiser."
                          :disabled? isFetching
                          :data-testid "list-advertisers"})]))
             ($ form-field
                ($ checkbox
                   (merge (form/use-bind-control [:default-agency?])
                          {:id :set-default-agency
                           :label "Always log in with this agency on this browser"})))
             ($ Button
                {:variant "contained"
                 :type "submit"}
                "Continue")
             ($ Button
                {:href (r.easy/href :common/login)
                 :onClick #(rf/dispatch [:resource.auth/logout])
                 :data-testid "back-to-login"}
                "← Go back to login page"))))))
